import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { LoaderContext } from "../../../../../Services/Loader_Provider_Service/LoadingContext";
import {
  uploadDoc,
  GetMasterSystemAlert,
  GetMasterTypeData,
} from "../../../../../Services/Global-Services/GlobalServices";
import { Dropdown } from "primereact/dropdown";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getEmployeeList } from "../../../EmployeeList/Service/employeeService";
import $ from "jquery";
import { TostMsg } from "../../../../../App";
import { addCourses } from "../../Services/SelfLearning";
import ERROR_LIST from "../../../../../Services/Global-Services/Hadle_Errors";
const LazyVideo = React.lazy(() =>
  import("../../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding")
);
function AddNewCourse() {
  const { showLoading, hideLoading } = useContext(LoaderContext);
  const [employeeList, setEmployeeList] = useState(null);
  const [selectedEmployees, setSelectedEmployees] = useState(null);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [ImagePath, setImagePath] = useState("/images/org-img/learn/add.png");
  const [videoPath, setVideoPath] = useState([]);
  const [file, setFile] = useState(null);
  const toster = useContext(TostMsg);
  const [selectedLang, setSelectedLang] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  useEffect(() => {
    getMaster(); 
    getEmployeeIdData();
  }, []);

  const getMaster = async () => {
    let params1 = {
      masterType: "LanguageType",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };
    let params2 = {
      masterType: "CategoryType",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };
    try {
      let responce = await GetMasterTypeData(params1);
      setSelectedLang(responce?.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
    try {
      let responce = await GetMasterTypeData(params2);
      setSelectedCategory(responce?.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  };

  const courseValidation = useMemo(
    () =>
      Yup.object().shape({
        CourseTitle: Yup.string().required("Course title is required."),
        categoryid: Yup.string().required("Category is required."),
        Instructor: Yup.string().required("Instructor is required."),
        LanguageId: Yup.string().required("Language is required."),
        CourseLevelId: Yup.string().required("Course level  is required."),
        CourseOriginalCost: Yup.string().required(
          "Course original cost is required."
        ),
        CourseContent: Yup.string().required("Course content is required."),
        WhatStudentwilllearn: Yup.string().required(
          "Student learn is required."
        ),
        CourseDiscountedCost: Yup.string().required(
          "Course discounted cost is required."
        ),
        Description: Yup.string().required("Description is required."),
        BannerImage: Yup.mixed()
          .required("Banner Image is required.")
          .test(
            "fileFormat",
            "Only png/gif/jpeg files are allowed",
            (value) => {
              if (value) {
                const supportedFormats = ["png", "gif", "jpeg", "jpg"];
                return supportedFormats.includes(value.split(".").pop());
              }
              return true;
            }
          ),
        // .test('fileSize', 'File size must be less than 10MB', value => {
        //     if (value) {
        //         return value.size <= 10145728;
        //     }
        //     return true;
        // }),
        // CourseInstructorId: Yup.string().required("is required."),

        TeaserVideo: Yup.mixed()
          .required("Teaser video is required.")
          .test("fileFormat", "Only mp4 files are allowed", (value) => {
            if (value) {
              const supportedFormats = ["mp4"];
              return supportedFormats.includes(value.split(".").pop());
            }
            return true;
          }),
        // .test('fileSize', 'File size must be less than 10MB', value => {
        //     if (value) {
        //         return value.size <= 10145728;
        //     }
        //     return true;
        // }),
      }),
    []
  );
  const courseForm = useFormik({
    initialValues: {
      CourseTitle: "",
      categoryid: "",
      Instructor: "",
      LanguageId: "",
      CourseLevelId: "",
      CourseOriginalCost: "",
      CourseContent: "",
      WhatStudentwilllearn: "",
      CourseDiscountedCost: "",
      Description: "",
      // CourseInstructorId: '',
      BannerImage: "",
      TeaserVideo: "",
    },
    validationSchema: courseValidation,
    onSubmit: useCallback(async (data) => {
      showLoading();
      let prams = {
        Id: 0,
        GUID: userDetails.GUID,
        IsActive: true,
        CreatedDate: new Date(),
        ModifiedDate: new Date(),
        CreatedBy: selectedEmployees.EmpId,
        ModifiedBy: userDetails.EmpId,
        OrgId: userDetails.OrgId,
        AccountId: userDetails?.OrgId,
        CourseInstructorId: data.Instructor,
        CourseTitle: data.CourseTitle,
        CourseLevelId: data.CourseLevelId,
        CourseOriginalCost: data.CourseOriginalCost,
        CourseDiscountedCost: data.CourseDiscountedCost,
        Description: data.Description,
        LanguageId: data.LanguageId,
        CourseContent: data.CourseContent,
        categoryid: data.categoryid,
        BannerImage: data.BannerImage, //ImagePath,
        IsFree: true,
        TeaserVideo: videoPath,
        Ispublish: true,
        CourseFor: "string",
        ByName: "string",
        Name: "string",
        IsBookMarked: 0,
        MyCourses: 0,
        Modules: 0,
        Lessons: 0,
        Quiz: 0,
        Duration: "string",
        ProfilePic: selectedEmployees.ProfileImage,
        UserPost: "string",
        IsBundle: 0,
        IsFollowing: 0,
        CourseCategory: "string",
        FirmName: "string",
        lstModules: [
          {
            Id: 0,
            GUID: userDetails.GUID,
            IsActive: true,
            CreatedDate: new Date(),
            ModifiedDate: new Date(),
            CreatedBy: userDetails.EmpId,
            ModifiedBy: userDetails.EmpId,
            OrgId: userDetails.OrgId,
            AccountId: userDetails?.OrgId,
            CourseId: 0,
            ModuleName: "string",
            Description: "string",
            lstLessons: [
              {
                Id: 0,
                GUID: userDetails.GUID,
                IsActive: true,
                CreatedDate: new Date(),
                ModifiedDate: new Date(),
                CreatedBy: userDetails.EmpId,
                ModifiedBy: userDetails.EmpId,
                OrgId: userDetails.OrgId,
                AccountId: userDetails?.OrgId,
                CourseId: 0,
                ModuleId: userDetails.EmpId,
                Title: "string",
                VideoURL: "string",
                Duration: "string",
                IsViewed: true,
              },
            ],
            lstQuiz: [
              {
                Id: 0,
                GUID: userDetails.GUID,
                IsActive: true,
                CreatedDate: new Date(),
                ModifiedDate: new Date(),
                CreatedBy: userDetails.EmpId,
                ModifiedBy: userDetails.EmpId,
                OrgId: userDetails.OrgId,
                AccountId: userDetails?.OrgId,
                CourseId: 0,
                ModuleId: userDetails.EmpId,
                QuizName: "string",
                IsQuizCompleted: true,
              },
            ],
            lstQuizQuestion: [
              {
                Id: 0,
                GUID: userDetails.GUID,
                IsActive: true,
                CreatedDate: new Date(),
                ModifiedDate: new Date(),
                CreatedBy: userDetails.EmpId,
                ModifiedBy: userDetails.EmpId,
                OrgId: userDetails.OrgId,
                QuestionText: "string",
                QuestionType: "string",
                AnsTypeId: 0,
                QUIZid: 0,
                CourseId: 0,
                ModuleId: userDetails.EmpId,
                lstQuestionOptions: [
                  {
                    Id: 0,
                    GUID: userDetails.GUID,
                    IsActive: true,
                    CreatedDate: new Date(),
                    ModifiedDate: new Date(),
                    CreatedBy: userDetails.EmpId,
                    ModifiedBy: userDetails.EmpId,
                    OrgId: userDetails.OrgId,
                    Empid: 0,
                    QuestionId: 0,
                    Options: "string",
                    IsCorrectId: true,
                    ModuleId: userDetails.EmpId,
                    QuizId: 0,
                    CourseId: 0,
                    LessonId: 0,
                    Answerid: 0,
                  },
                ],
              },
            ],
          },
        ],
        lstBundledCourses: [
          {
            Id: 0,
            GUID: userDetails.GUID,
            IsActive: true,
            CreatedDate: new Date(),
            ModifiedDate: new Date(),
            CreatedBy: userDetails.EmpId,
            ModifiedBy: userDetails.EmpId,
            OrgId: userDetails.OrgId,
            AccountId: userDetails?.OrgId,
            CourseInstructorId: 0,
            CourseTitle: "string",
            CourseLevelId: 0,
            CourseOriginalCost: "string",
            CourseDiscountedCost: "string",
            BannerImage: "string",
            IsFree: true,
            TeaserVideo: "string",
            Description: "string",
            LanguageId: 0,
            CourseFor: "string",
            ByName: "string",
            Name: "string",
            IsBookMarked: 0,
            Modules: 0,
            Lessons: 0,
            Quiz: 0,
            Duration: "string",
            ProfilePic: "string",
            UserPost: "string",
            IsBundle: 0,
            IsFollowing: 0,
            BundleId: 0,
          },
        ],
      };
      try {
        await addCourses(prams);
        hideLoading();
      } catch (err) {
        hideLoading();
      }
    }, []),
  });

  //For get the employee data.
  async function getEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
    };
    showLoading();
    try {
      let employeesList = await getEmployeeList(params);
      // let employeesList = await data.json();
      setEmployeeList(employeesList.Data);
      hideLoading();
    } catch (error) {
      hideLoading();
      // Handle error
    }
  }
  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2">
        <img alt={option.FullName} src={option.ProfileImage} width="32" />
        <span>{option.FullName}</span>
      </div>
    );
  };

  // Inner HTML for image
  const fileInputImageRef = useRef(null);
  function openFileImageInput() {
    fileInputImageRef.current.click();
  }

  // Upload your feed image and video data
  const handleImageFileChange = useCallback(async (event) => {
    const selectedFile = await event.target.files[0];
    setFile(selectedFile);
  }, []);

  // Inner HTML for video
  const fileInputVideoRef = useRef(null);
  function openFileVideoInput() {
    fileInputVideoRef.current.click();
  }

  const handleVideoFileChange = useCallback(async (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  }, []);

  useEffect(() => {
    if (file) {
      uploadPolicyDocFile();
    }
  }, [file]);
  // Upload your image and video data
  const uploadPolicyDocFile = useCallback(
    async (file, type) => {
      showLoading();
      if (file) {
        const formData = new FormData();
        formData.append("files", file);
        try {
          const response = await uploadDoc(formData);
          const data = await response;
          hideLoading();
          const ImageURL = data?.Data[0];
          $(".upload-img").hide("slow");
          $(".input-Btn").show("slow");
          if (ImageURL.slice(-3) == "mp4") {
            hideLoading();
            // let PostMedia = [];
            // PostMedia = {
            //     MediaName: 104,
            //     MediaPath: ImageURL,
            // };
            // setVideoPath((video) => [...video, PostMedia]);
            setVideoPath(ImageURL);
            courseForm.setFieldValue("TeaserVideo", ImageURL);
            setFile(null);
          } else {
            hideLoading();
            // let PostMedia = [];
            // PostMedia = {
            //     MediaName: 103,
            //     MediaPath: ImageURL,
            // };
            // setImagePath((image) => [...image, PostMedia]);

            setImagePath(ImageURL);
            courseForm.setFieldValue("BannerImage", ImageURL);
            setFile(null);
          }
        } catch (error) {
          setFile(null);
          hideLoading();
        toster.current.error(ERROR_LIST.UploadFileError);
        } finally {
          setFile(null);
          hideLoading();
        }
      } else {
        hideLoading();
        setFile(null);
        toster.current.warn("No file selected.");
      }
    },
    [uploadDoc, showLoading, hideLoading, toster, courseForm]
  );

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid">
        <div className="col-md-8 shrink-w">
          <div className="form-head d-flex flex-wrap align-items-center mb-3">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Add New Course</h2>
              <p className="text-light">Lorem ipsum dolor sit amet</p>
            </div>
            <div className="rightside-tabs">
              <Link to="CourseDetail">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="currentColor"
                  className="bi bi-arrow-left-short"
                  viewBox="0 0
 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 8a.5.5 0 0 1-.5.5H5.7
 07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
 .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                  ></path>
                </svg>
              </Link>
            </div>
          </div>

          <form onSubmit={courseForm.handleSubmit}>
            <div className="row">
              <div className="col-xl-8">
                <div className="col-xl-12">
                  <div className="supp-req">
                    <div className="addcourseform">
                      <div className="row">
                        <div className="mb-4 col-md-12">
                          <input
                            type="text"
                            cols="1"
                            rows="4"
                            className={
                              "form-control bg-chng" +
                              (courseForm.errors.CourseTitle &&
                              courseForm.touched.CourseTitle
                                ? "is-invalid"
                                : "")
                            }
                            placeholder="Your Course title goes here..|"
                            onChange={courseForm.handleChange}
                            value={courseForm.values.CourseTitle}
                            name="CourseTitle"
                          />
                          <div className="invalid-feedback">
                            {courseForm.errors.CourseTitle &&
                            courseForm.touched.CourseTitle
                              ? courseForm.errors.CourseTitle
                              : null}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="mb-4 col-md-6">
                          <label className="form-label">Category</label>
                          <div className="cover-form">
                            <div className="div">
                              <i
                                className="fa fa-bookmark-o"
                                aria-hidden="true"
                              ></i>
                              <Dropdown
                                value={courseForm.values.categoryid}
                                onChange={(e) => {
                                  courseForm.setFieldValue(
                                    "categoryid",
                                    e.value.Id
                                  );
                                }}
                                options={selectedCategory}
                                optionLabel="Name"
                                placeholder="Choose..."
                                checkmark={true}
                                highlightOnSelect={false}
                              />
                              <div className="invalid-feedback">
                                {courseForm.errors.categoryid &&
                                courseForm.touched.categoryid
                                  ? courseForm.errors.categoryid
                                  : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-4 col-md-6">
                          <label className="form-label">Instructor</label>
                          <div className="cover-form">
                            <div className="div">
                              <i
                                className="fa fa-user-o"
                                aria-hidden="true"
                              ></i>
                              <Dropdown
                                value={courseForm.values.Instructor}
                                onChange={(e) => {
                                  courseForm.setFieldValue(
                                    "Instructor",
                                    e.value.EmpId
                                  );
                                  setSelectedEmployees(e.value);
                                }}
                                options={employeeList}
                                filter={true}
                                optionLabel="FullName"
                                placeholder="Select Employee"
                                maxSelectedLabels={1}
                                itemTemplate={employeeOptionTemplate}
                                className="w-full md:w-20rem custom-multiselect"
                              />
                              <div className="invalid-feedback">
                                {courseForm.errors.Instructor &&
                                courseForm.touched.Instructor
                                  ? courseForm.errors.Instructor
                                  : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-4 col-md-6">
                          <label className="form-label">Language</label>
                          <div className="cover-form">
                            <div className="div">
                              <i
                                className="fa fa-user-o"
                                aria-hidden="true"
                              ></i>
                              <Dropdown
                                value={courseForm.values.LanguageId}
                                onChange={(e) => {
                                  courseForm.setFieldValue(
                                    "LanguageId",
                                    e.value.Id
                                  );
                                }}
                                options={selectedLang}
                                optionLabel="Name"
                                placeholder="Choose..."
                                checkmark={true}
                                highlightOnSelect={false}
                              />
                              <div className="invalid-feedback">
                                {courseForm.errors.LanguageId &&
                                courseForm.touched.LanguageId
                                  ? courseForm.errors.LanguageId
                                  : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-4 col-md-6">
                          <label className="form-label">Level</label>
                          <div className="cover-form">
                            <div className="div">
                              <i
                                className="fa fa-user-o"
                                aria-hidden="true"
                              ></i>
                              <Dropdown
                                value={courseForm.values.CourseLevelId}
                                onChange={(e) => {
                                  courseForm.setFieldValue(
                                    "CourseLevelId",
                                    e.value.Id
                                  );
                                }}
                                options={selectedCategory}
                                optionLabel="Name"
                                placeholder="Choose..."
                                checkmark={true}
                                highlightOnSelect={false}
                              />
                              <div className="invalid-feedback">
                                {courseForm.errors.CourseLevelId &&
                                courseForm.touched.CourseLevelId
                                  ? courseForm.errors.CourseLevelId
                                  : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-4 col-md-6">
                          <label className="form-label">Original Price</label>
                          <div className="cover-form">
                            <div className="div">
                              <i className="fa fa-money" aria-hidden="true"></i>
                              <input
                                type="number"
                                onChange={courseForm.handleChange}
                                name="CourseOriginalCost"
                                value={courseForm.values.CourseOriginalCost}
                                className={
                                  "form-control" +
                                  (courseForm.errors.CourseOriginalCost &&
                                  courseForm.touched.CourseOriginalCost
                                    ? "is-invalid"
                                    : "")
                                }
                              />
                            </div>
                            <div className="invalid-feedback">
                              {courseForm.errors.CourseOriginalCost &&
                              courseForm.touched.CourseOriginalCost
                                ? courseForm.errors.CourseOriginalCost
                                : null}
                            </div>
                          </div>
                        </div>
                        <div className="mb-4 col-md-6">
                          <label className="form-label">Discounted Price</label>
                          <div className="cover-form">
                            <div className="div">
                              <i className="fa fa-money" aria-hidden="true"></i>
                              <input
                                type="number"
                                onChange={courseForm.handleChange}
                                name="CourseDiscountedCost"
                                value={courseForm.values.CourseDiscountedCost}
                                className={
                                  "form-control" +
                                  (courseForm.errors.CourseDiscountedCost &&
                                  courseForm.touched.CourseDiscountedCost
                                    ? "is-invalid"
                                    : "")
                                }
                              />
                            </div>
                            <div className="invalid-feedback">
                              {courseForm.errors.CourseDiscountedCost &&
                              courseForm.touched.CourseDiscountedCost
                                ? courseForm.errors.CourseDiscountedCost
                                : null}
                            </div>
                          </div>
                        </div>
                        <div className="mb-4 col-md-12">
                          <label className="form-label">Course Content</label>
                          <div className="cover-form">
                            <textarea
                              onChange={courseForm.handleChange}
                              name="CourseContent"
                              value={courseForm.values.CourseContent}
                              className={
                                "form-control h-auto" +
                                (courseForm.errors.CourseContent &&
                                courseForm.touched.CourseContent
                                  ? "is-invalid"
                                  : "")
                              }
                              rows="4"
                              cols="1"
                              placeholder="write some lines about this course.."
                            ></textarea>
                          </div>
                          <div className="invalid-feedback">
                            {courseForm.errors.CourseContent &&
                            courseForm.touched.CourseContent
                              ? courseForm.errors.CourseContent
                              : null}
                          </div>
                        </div>
                        <div className="mb-4 col-md-12">
                          <label className="form-label">Description</label>
                          <div className="cover-form">
                            <textarea
                              onChange={courseForm.handleChange}
                              name="Description"
                              value={courseForm.values.Description}
                              className={
                                "form-control h-auto" +
                                (courseForm.errors.Description &&
                                courseForm.touched.Description
                                  ? "is-invalid"
                                  : "")
                              }
                              rows="6"
                              cols="1"
                              placeholder="write some lines about this course.."
                            ></textarea>
                          </div>
                          <div className="invalid-feedback">
                            {courseForm.errors.Description &&
                            courseForm.touched.Description
                              ? courseForm.errors.Description
                              : null}
                          </div>
                        </div>
                        <div className="mb-4 col-md-12">
                          <label className="form-label">
                            What Student will learn
                          </label>
                          <div className="cover-form">
                            <div>
                              <i
                                className="fa fa-sticky-note-o"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <input
                              type="text"
                              onChange={courseForm.handleChange}
                              name="WhatStudentwilllearn"
                              value={courseForm.values.WhatStudentwilllearn}
                              className={
                                "form-control" +
                                (courseForm.errors.WhatStudentwilllearn &&
                                courseForm.touched.WhatStudentwilllearn
                                  ? "is-invalid"
                                  : "")
                              }
                              placeholder="How to create wireframes..."
                            />
                          </div>
                          <div className="invalid-feedback">
                            {courseForm.errors.WhatStudentwilllearn &&
                            courseForm.touched.WhatStudentwilllearn
                              ? courseForm.errors.WhatStudentwilllearn
                              : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="card">
                      <div className="card-body">
                        <div
                          onClick={() => {
                            openFileImageInput();
                          }}
                          className="loadresumes"
                        >
                          <div className="inner">
                            <img src={ImagePath} className="w-100" />
                            <span>Upload Cover Image</span>
                          </div>
                          {/* <input
                                                        className="form-control"
                                                        name="file"
                                                        type="file"
                                                        onChange={handleImageFileChange}
                                                        id="fileInput"
                                                        accept="image/png, image/gif, image/jpeg"
                                                        ref={fileInputImageRef}
                                                        style={{ display: "none" }}
                                                    /> */}

                          <input
                            type="file"
                            ref={fileInputImageRef}
                            style={{ display: "none" }}
                            className="form-control"
                            name="BannerImage"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={handleImageFileChange}
                          />
                        </div>
                        <div>
                          {courseForm.errors.BannerImage ? (
                            <p style={{ color: "red" }}>
                              {courseForm.errors.BannerImage}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-body">
                        <div
                          onClick={openFileVideoInput}
                          className="loadresumes"
                        >
                          <div className="inner">
                            {videoPath?.length == 0 ? (
                              <img src="/images/org-img/learn/add.png" />
                            ) : (
                              <LazyVideo src={videoPath} />
                            )}
                            <span>Upload Video</span>
                          </div>
                          <input
                            className="form-control"
                            name="TeaserVideo"
                            type="file"
                            onChange={handleVideoFileChange}
                            id="fileInput"
                            accept="video/*"
                            ref={fileInputVideoRef}
                            style={{ display: "none" }}
                          />
                          {/* <input
                                                        className="form-control"
                                                        name="file"
                                                        type="file"
                                                        onChange={handleVideoFileChange}
                                                        id="fileInput"
                                                        accept="video/*"
                                                        ref={fileInputVideoRef}
                                                        style={{ display: "none" }}
                                                    /> */}
                        </div>
                        <div>
                          {courseForm.errors.TeaserVideo ? (
                            <p style={{ color: "red" }}>
                              {courseForm.errors.TeaserVideo}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="btns-grp">
                  <button type="submit" className="savebtn-click">
                    Save
                  </button>
                  <button type="submit" className="publish-click">
                    Publish
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="modal fade" id="give-rating">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <img src="/images/org-img/learn/rate.png" />
            <div className="modal-header p-0">
              <h5 className="modal-title m-auto">
                How would you rate your course experience?
              </h5>
            </div>
            <div className="modal-body text-center">
              <ul className="rate">
                <li>
                  <i className="fa fa-star"></i>
                </li>
                <li>
                  <i className="fa fa-star"></i>
                </li>
                <li>
                  <i className="fa fa-star"></i>
                </li>
                <li>
                  <i className="fa fa-star-o"></i>
                </li>
                <li>
                  <i className="fa fa-star-o"></i>
                </li>
              </ul>
              <div className="form-group text-left">
                <textarea
                  rows="6"
                  cols="1"
                  className="form-control"
                  placeholder="I would like to say that..."
                ></textarea>
              </div>
            </div>
            <div className="modal-footer">
              <i className="fa fa-angle-right" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AddNewCourse;
